export const MAIN_PAGE = '/';

export const SCHEDULE = '/schedule';
export const CONTENT = '/content';
export const GROW = '/grow';
export const REPORT = '/report';